<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <button type="button" @click="back()" class="btn btn-default mb-10">
                    <i class="fa fa-angle-left"></i>
                    Voltar
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="search">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-search"></i> Cliente
                        </div>

                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Nome:</label>
                                    {{ model.nome}}
                                </div>
                                <div class="col-md-4">
                                    <label>CPF:</label>
                                    {{ model.cpf}}
                                </div>
                                <div class="col-md-4">
                                    <label>Telefone:</label>
                                    {{ model.telefone}}
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group row">
                                <div class="col-md-6 text-left">
                                    <button type="button" @click="create" class="btn btn-primary">
                                        Adicionar Pet
                                        <i class="fa fa-angle-right"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <dw-table-header :size="size" @finish="updateSize" :pagination="list"></dw-table-header>
                    </div>
                    <div class="card-block">
                        <table class="table table-bordered table-striped table-md">
                            <dw-table-head :headers="headers" :editable="true" @update="sort"></dw-table-head>
                            <tbody>
                                <tr v-for="item in list.rows">
                                    <td :data-label="headers[0].name">{{item.id }}</td>
                                    <td :data-label="headers[1].name">{{item.nome}}</td>
                                    <td :data-label="headers[2].name">
                                        <span v-if="item.tipo=='C'">Cão</span>
                                        <span v-if="item.tipo=='G'">Gato</span>
                                    </td>
                                    <td :data-label="headers[3].name">{{item.raca.nome}}</td>
                                    <td :data-label="headers[3].name">
                                        <span v-if="item.tamanho=='P'">Pequeno</span>
                                        <span v-if="item.tamanho=='M'">Médio</span>
                                        <span v-if="item.tamanho=='G'">Grande</span>
                                    </td>
                                    <td :data-label="headers[3].name">
                                        <span v-if="item.sexo=='F'">Fêmea</span>
                                        <span v-if="item.sexo=='M'">Macho</span>
                                    </td>
                                    <td
                                        :data-label="headers[1].name"
                                    >{{item.nascimento |formatDate('DD/MM/YYYY')}}</td>
                                    <td>
                                        <button
                                            title="Editar"
                                            class="btn btn-primary btn-sm"
                                            @click="edit(item.id)"
                                            v-tooltip="'Editar'"
                                        >
                                            <i class="far fa-edit"></i>
                                        </button>
                                        <button
                                            title="Vacinas"
                                            class="btn btn-info btn-sm"
                                            @click="vaccine(item.id)"
                                            v-tooltip="'Vacinas'"
                                        >
                                            <i class="fas fa-syringe"></i>
                                        </button>

                                        <button
                                            title="Exames"
                                            class="btn btn-primary btn-sm"
                                            @click="exams(item.id)"
                                            v-tooltip="'Exames'"
                                        >
                                            <i class="fas fa-file-medical-alt"></i>
                                        </button>

                                        <button
                                            title="Banhos"
                                            class="btn btn-info btn-sm"
                                            @click="bath(item.id)"
                                            v-tooltip="'Banhos'"
                                        >
                                            <i class="fas fa-bath"></i>
                                        </button>
                                        <button
                                            title="Peso"
                                            class="btn btn-primary btn-sm"
                                            @click="weight(item.id)"
                                            v-tooltip="'Pesos'"
                                        >
                                            <i class="fas fa-weight-hanging"></i>
                                        </button>

                                        <button
                                            title="Consulta"
                                            class="btn btn-info btn-sm"
                                            @click="consultation(item.id)"
                                            v-tooltip="'Consultas'"
                                        >
                                            <i class="fas fa-notes-medical"></i>
                                        </button>
                                        <button
                                            title="Medicamentos"
                                            class="btn btn-primary btn-sm"
                                            @click="medicine(item.id)"
                                            v-tooltip="'Medicamentos'"
                                        >
                                            <i class="fas fa-pills"></i>
                                        </button>
                                        <button
                                            title="Excluir"
                                            class="btn btn-danger btn-sm"
                                            @click="remove(item.id)"
                                            v-tooltip="'Remover'"
                                        >
                                            <i class="far fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <dw-pagination
                            :pagination="list"
                            :page="page"
                            @update="fetchData"
                            :offset="size"
                        ></dw-pagination>
                    </div>
                </div>
            </div>
            <!--/.col-->
        </div>
        <!--/.row-->
    </div>
</template>

<script>
import {
    isUndefinedOrNullOrEmpty,
    clearCpfCnpj,
    clearPhone,
    formatPhone,
    formatCpf
} from "@/services/string";
import SelectClient from "../../components/Input/SelectClient";
import Select from "../../components/Input/Select";
import SelectApi from "../../components/Input/SelectApi";
import Collections from "@/helpers/collections";
import Facade from "../../facade/facade";
import "bootstrap/dist/css/bootstrap.min.css";
import sass from "@/assets/sass/style.scss";
const facade = new Facade();

export default {
    components: { SelectClient, SelectApi, Select },
    data() {
        return {
            headers: [
                { name: "Cód.", key: "id" },
                { name: "Nome", key: "nome" },
                { name: "Espécie", key: "tipo" },
                { name: "Raça", key: "`raca.nome`" },
                { name: "Tamanho", key: "tamanho`" },
                { name: "Sexo", key: "sexo`" },
                { name: "Nascimento", key: "nascimento`" }
            ],
            list: {},
            idCliente: null,
            idPet: null,
            filter: {},
            size: 20,
            page: 0,
            order: ["id", "ASC"],
            model: {}
        };
    },
    computed: {
        isAdmin() {
            return facade.isAdmin();
        }
    },
    methods: {
        sort(data) {
            this.order = [data.key, data.direction];
            this.fetchData(this.page);
        },
        back() {
            this.$router.push({ name: "list-client" });
        },
        clean() {
            this.filter = {
                id_atividade: null,
                id_evento: null
            };
            this.atividades = [];
        },
        create() {
            this.$router.push({ name: "new-pet" });
        },

        edit(id) {
            this.$router.push({
                name: "edit-pet",
                params: { id: id }
            });
        },
        vaccine(id) {
            this.$router.push({
                name: "list-vaccines-pet",
                params: { idCliente: this.$route.params.idCliente, id: id }
            });
        },
        exams(id) {
            this.$router.push({
                name: "list-exams-pet",
                params: { idCliente: this.$route.params.idCliente, id: id }
            });
        },
        weight(id) {
            this.$router.push({
                name: "list-weight-pet",
                params: { idCliente: this.$route.params.idCliente, id: id }
            });
        },
        bath(id) {
            this.$router.push({
                name: "list-bath-pet",
                params: { idCliente: this.$route.params.idCliente, id: id }
            });
        },
        consultation(id) {
            this.$router.push({
                name: "list-consultation-pet",
                params: { idCliente: this.$route.params.idCliente, id: id }
            });
        },
        medicine(id) {
            this.$router.push({
                name: "list-medicine-pet",
                params: {
                    idCliente: this.$route.params.idCliente,
                    id: id
                }
            });
        },
        remove(id) {
            this.$swal({
                title: "Você tem certeza?",
                text: "Não será possível  reverter esta operação",
                showCancelButton: true,
                confirmButtonText: "Sim, deletar!",
                cancelButtonText: "Não, cancelar!"
            }).then(
                () => {
                    this.$loading.show(true);

                    let ret = facade.deletePet(
                        id,
                        this.$route.params.idCliente
                    );
                    ret.then(response => {
                        this.$notify.success(
                            "",
                            "Registro removido com sucesso."
                        );
                        this.fetchData(0);
                        this.$loading.show(false);
                    }).catch(e => {
                        this.$notify.error(
                            "Erro!",
                            "Ocorreu um problema ao deletar o pet."
                        );
                        this.$loading.show(false);
                    });
                },
                dismiss => {}
            );
        },

        fetchData(page) {
            let vm = this;
            vm.page = page;

            let params = {
                params: {
                    page: page,
                    size: vm.size,
                    order: vm.order
                }
            };
            for (let key in this.filter) {
                if (this.filter.hasOwnProperty(key)) {
                    params["params"][key] = this.filter[key];
                }
            }

            this.$loading.show(true);
            let ret = facade.listPet(params, this.$route.params.idCliente);
            ret.then(response => {
                vm.list = response.data.data;
                this.$loading.show(false);
            }).catch(e => {
                this.$notify.error(
                    "Erro!",
                    "Ocorreu um problema ao listar os pets."
                );
                this.$loading.show(false);
            });
        },
        search() {
            this.fetchData(0);
        },
        updateSize(value) {
            let vm = this;
            vm.size = value;
            this.fetchData(0);
        },
        setData(client) {
            if (client !== undefined && client !== null) {
                client.telefone = client.telefone
                    ? formatPhone(client.telefone)
                    : "";
                client.cpf = client.cpf ? formatCpf(client.cpf) : "";
                this.model = client;
            }
        }
    },
    beforeMount() {
        this.fetchData(0);
    },

    beforeRouteEnter(to, from, next) {
        const vm = this;
        Promise.all([
            to.params.idCliente ? facade.getClient(to.params.idCliente) : null
        ])
            .then(response => {
                next(vm =>
                    vm.setData(
                        response[0] != null ? response[0].data.data : null
                    )
                );
            })
            .catch(e => {
                next(vm => vm.setData());
            });
    }
};
</script>



// WEBPACK FOOTER //
// List.vue?11d1d504